module.exports = __webpack_public_path__ + "img/40_38_071_960.5645fe83.jpg";